import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { Stack } from "@mui/system";
import PopupWithButton from "./PopupWithButton";
import { FaShoppingCart } from "react-icons/fa";
import { AiFillCloseCircle } from "react-icons/ai";
import "react-slideshow-image/dist/styles.css";
import { Slide } from "react-slideshow-image";
import colors from "../config/colors";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import apiClient from "../api/apiClient";

const Menu = [
  {
    id: 1,
    Image: [
      require("../../src/assets/img/Car1.jpeg"),
      require("../../src/assets/img/Car2.jpg"),
      require("../../src/assets/img/Car3.jpg"),
    ],
    name: "Car",
    impression: "27,00000/mth",

    types: ["Uber ", "  Lyft ", "  Gig Economy "],

    type: "vehicle",
    Vehicle_info: {
      avg_imp: "1,000,000/mth",
      dimenstions: ["-Compact", "-Midsize", "-XL Vehicle"],
      sold_by: ["Weekly", "Monthly"],
      fule_type: "Gas, hybrid, electric",
    },
    Vehicle_KPI: {
      best_user: [
        "Swram 10+units,",
        "one on one",
        "viewers, electric",
        "cars available",
      ],
      local_drivers: [
        "Professional brand ambassadors,",
        "trustworthy,",
        "ride share",
      ],
      routes: ["local,", "neighborhoods,", "residential areas,", "highways"],
    },
    drive_time: {
      hours: "7am to 7pm",
      days: "6 days per week",
      months: "200 hours per mth",
    },
  },

  {
    id: 2,
    Image: [
      require("../../src/assets/img/BoxTruck1.jpg"),
      require("../../src/assets/img/BoxTruck2.jpg"),
      require("../../src/assets/img/BoxTruck3.jpg"),
    ],
    name: "Box Truck",
    impression: "2,700,000/mth",
    types: ["Local", "Commercial", "Lastmile"],

    type: "veicle",
    Vehicle_info: {
      avg_imp: "2,700,000/mth",
      dimenstions: ["Side- 8x26ft", "Rear- 8x8ft", "Front- 3x7ft"],
      sold_by: ["3 months", "6 months", "12 months"],
      ad_space: "500 sq. ft.",
    },
    Vehicle_KPI: {
      best_user: [
        "Local market",
        "saturation,",
        "local street presence,",
        "special events",
      ],
      local_drivers: ["Commercial,", "professional,", " background checked"],
      routes: [
        "Dedicated daily",
        "routes in",
        "neighbordhoods",
        "and or highways",
      ],
    },
    drive_time: {
      hours: "7am to 7pm",
      days: "6 days per week",
      months: "200 hours per mth.",
    },
  },

  {
    id: 3,
    Image: [
      require("../../src/assets/img/LEDTruck1.jpeg"),
      require("../../src/assets/img/LEDTruck2.jpeg"),
      require("../../src/assets/img/LEDTruck3.jpeg"),
    ],
    name: "LED Truck",
    impression: "1,000,000/mth",
    types: ["Fully Customizable Routes"],

    type: "veicle",
    Vehicle_info: {
      avg_imp: "1,000,000/mth",
      dimenstions: ["Side-6.5x11.5ft", "Rear- 6x6ft"],
      sold_by: ["8 hours slots", "3 -days", "Weekly"],
      ad_space: "185 sq. ft.",
    },
    Vehicle_KPI: {
      best_user: [
        "Static/video,",
        "displays,",
        "competition,",
        "targeting, political",
      ],
      local_drivers: ["professional brand ambassadors,", "trustworthy"],
      routes: ["100% custom", "routes for client,", "no higways"],
    },
    drive_time: {
      hours: "7am to 7pm",
      days: "6 days per week",
      months: "200 hours per mth.",
    },
  },

  {
    id: 4,
    Image: [
      require("../../src/assets/img/Semi1.JPG"),
      require("../../src/assets/img/Semi2.jpg"),
    ],
    name: "Semi Truck",
    impression: "2,000,000/mth",
    types: ["Regional ", " Comercial ", " Freeway "],

    type: "veicle",
    Vehicle_info: {
      avg_imp: "3,000,000/mth",
      dimenstions: ["Side- 8x53ft", "Rear- 8x8ft"],
      sold_by: ["3 months", "6 months", "12 months"],
      ad_space: "912 sq. ft.",
    },
    Vehicle_KPI: {
      best_user: [
        "Great for multi-state",
        "campaigns,",
        "reach millions of",
        "eyes on highways",
      ],
      local_drivers: ["Commercial,", "professional,", "background checked"],
      routes: ["Highways,", "freeways,", "long distance driving"],
    },
    drive_time: {
      hours: "7am to 7pm",
      days: "6 days per week",
      months: "200 hours per mth.",
    },
  },

  {
    id: 4,
    Image: [
      require("../../src/assets/img/Retargeting1.png"),
      require("../../src/assets/img/Retargeting2.jpg"),
      require("../../src/assets/img/Retargeting3.png"),
    ],
    name: "Retargeting Impressions",
    type: "other",
    description:
      "Once a candidate enters the capture radius of a vehicle, their mobile phone's advertising ID is captured by our beacon technology. We can then filter this audience down by over 200 affinity groups (age, gender, income, interests, etc), and serve display ads in-app or in- browser, driving them to your careers page or specific job postings. We can also provide the entire collected audience if you would like to advertise to them through your own channels (sold in 200k impression intervals).",
  },
  {
    id: 5,
    Image: [require("../../src/assets/img/swram.PNG")],
    name: "Swarm",
    type: "other",
    description:
      "Introducing Swarm, the ultimate advertising solution for businesses looking to increase visibility and reach in a specific location. With Swarm, you can send a fleet of advertiser vehicles, including box trucks, LED trucks, and wrapped cars, around a specific location or to and from a specific location. This allows many eyes to be on your advertisement in that specific area and time, maximizing your brand's exposure and impact. Get your message out there with Swarm and Drive more customers to your business today.",
  },
  {
    id: 6,
    Image: [require("../../src/assets/img/Photoshoot.jpeg")],
    name: "Photo/Video",
    type: "other",
    description:
      "Introducing Rolling Adz's photoshoot and video package - the perfect way to showcase your advertisement on our mobile billboards in a visually stunning and professional manner. Our package includes photoshoots and video of your advertisement on our box trucks, LED trucks, semi trucks and wrapped cars. You'll receive high-resolution images and videos, professionally edited and ready to use for your website, social media or other marketing materials.",
  },
];

export default () => {
  const [open, setopen] = useState();
  const [current, setCurrent] = useState();
  const { isLoggedIn, userType } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  useEffect(() => {
    if (isLoggedIn) handleNavigate(userType);
  });
  function handleNavigate(role) {
    if (role == "IN") navigate("/installeraccount");
    else if (role == "PH") navigate("/photograperaccount");
    else if (role == "AC") navigate("/advertiser-account");
    else if (role == "VO") navigate("/vehicleowneraccount");
    else if (role == 5) navigate("/driver-search-result");
  }
  useEffect(()=>{
    document.title = "RollingAdz: Dashboard" || "Default Title";
  },[])
  return (
    <div>
      <div className="container-fluid gx-0">
        <div className="row">
          <div className="col">
            <div className="d-md-flex justify-content-md-between bg_header px-3 pb-md-0 pb-3">
              <div className="logo_img_style mx-md-0 mx-auto">
                <img
                  src={require(".././assets/img/rolling-adz-logo.png")}
                  className
                  width="100%"
                  alt=""
                />
              </div>
              <Box className="my-auto text-center text-md-start ">
                <Box sx={{display:{sm:"inline-block",xs:"none"}}}>
                <Link
                  to={"/agency-packages"}
                  className="btn Request_color fs-4"
                >
                  Campaign Packages
                </Link>
                </Box>
                <Box sx={{display:{sm:"inline-block",xs:"none"}}}>
                <Link to={"/signin"}>
                  <button className="btn SignIn_color text-white fs-4 ps-2">
                    Sign in/Sign up
                  </button>
                </Link>
                </Box>
                {/* <Link to={"/request-comapaign"}>
                  <FaShoppingCart
                    style={{ paddingLeft: "10px" }}
                    color="#0074AC"
                    size={35}
                  />
                </Link> */}
                <div></div>
              </Box>
            </div>
          </div>
        </div>

        <div className="container-fluid row">
          <div className="col-lg-7 col-md-6 map_height">
            <div className="h-100 index_bg my-auto d-flex justify-content-center ">
              <Box sx={{ marginTop: "150px" }}>
                <p className="text-white">
                  Welcome to Rolling Adz Mobile Billboards
                </p>
                <h1 className="text-white">
                  Mobile. Distinctive. Powerful.
                  <br /> Billboards
                </h1>
                <Box className="justify-content-center" sx={{display:{sm:"none",xs:"flex"}}}>
                <Link to={"/signin"}>
                  <button className="btn SignIn_color text-white fs-4 ps-2">
                    Sign in/Sign up
                  </button>
                </Link>
                </Box>

              </Box>
              
              {/* <iframe className="w-100 h-100" src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d13465.913109294252!2d74.51117165!3d32.45989695000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2s!4v1674630598202!5m2!1sen!2s" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" /> */}
            </div>
          </div>

          <div className="col-lg-5 col-md-6 bg_sky">
            <div>
              <div className="Drivers my-2">
                <h5 className="mx-auto">Available Products</h5>
              </div>
            </div>
            <div className="row allContacts  reight_side_height">
              {Menu.map((item) => (
                <div
                  onClick={() => {
                    setCurrent(item);
                    setopen(true);
                  }}
                  className="col-md-6 col-sm-6 px-1 mb-2"
                >
                  <div
                    className="card card_border div_posetion rounded-4"
                    style={{ borderRadius: "11px" }}
                  >
                    <img
                      className="card-img-top rounded-top-4"
                      src={item.Image[0]}
                      alt="Card image"
                      style={{ width: "100%", height: "220px" }}
                    />
                    <div className="photo_button d-flex justify-content-between">
                      <button className="px-3 py-2 rounded-pill bg-dark">
                        <b>{item.name}</b>
                      </button>
                      <div className="my-auto">
                        {/* <i className="bi bi-heart text-danger pe-1" /> */}
                        <i className="text-white bi bi-plus-circle text-primary" />
                      </div>
                    </div>
                    {item.impression && (
                      <div className=" card-body py-1 px-lg-2 px-md-1 px-2 top_border rounded-bottom-4">
                        <div className="  d-flex mb-1  fw-bold flex-wrap">
                          {item.types?.map((item_c, index) => (
                            <div className="align-items-start" key={index}>
                              <p className="">
                                {item_c}
                                {index < item.types.length - 1 && (
                                  <span className="mx-1">|</span>
                                )}
                              </p>
                            </div>
                          ))}
                        </div>
                        {item.Vehicle_info?.avg_imp && (
                          <p className=" mb-1 fs_14px">
                            Avg. Impressions:
                            <span className="">
                              {item.Vehicle_info.avg_imp}
                            </span>
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {current && (
        <>
          {current.type == "other" ? (
            <EventCard open={open} item={current} setopen={setopen} />
          ) : (
            <NewCard open={open} item={current} setopen={setopen} />
          )}
        </>
      )}
    </div>
  );
};

function NewCard({ open, setopen, item }) {
  function handleSubmit() {}
  const navigate = useNavigate();

  return (
    <>
      <PopupWithButton
        title=""
        content={
          <div className="">
            <div className="">
              <div className="row">
                <div className=" col-2 d-flex align-items-center justify-content-center">
                  <div onClick={() => setopen(false)}>
                    <AiFillCloseCircle size={30} color={colors.primary} />
                  </div>
                </div>
                <div className=" col-7 d-flex align-items-center justify-content-center">
                  <h4
                    className="text_color text-decoration-underline"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Vehicle: {item.name}
                  </h4>
                </div>
                <div className=" col-3 d-flex align-items-center justify-content-end">
                  <div style={{ width: "8rem" }}>
                    <img
                      width="100%"
                      src={require("../assets/img/rolling_roz.png")}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="">
              <Slide>
                {item.Image?.map((item, key) => (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundSize: "cover",
                        height: "340px",
                        backgroundImage: `url(${item})`,
                      }}
                    >
                      {/* <span>Slide 1</span> */}
                    </div>
                  </div>
                ))}
              </Slide>
            </div>
            {/* <img className="card_img_top img-fluid" src={item.Image} alt="Card image" style={{width: '100%', height: 'auto'}} /> */}
            <div className="box_bg p-3 border border-secondary rounded mt-2">
              <h5 className="text_color text-decoration-underline">
                Vehicle Info:
              </h5>
              <div className="row">
                <div className="col-md-4">
                  <h6 className="text-muted">Avg.Impression:</h6>

                  <p className="fs_14px">{item.Vehicle_info.avg_imp}</p>
                  {item.Vehicle_info.ad_space && (
                    <div>
                      <h6 className="text-muted">Ad Space</h6>
                      <p className="fs_14px">{item.Vehicle_info.ad_space}</p>
                    </div>
                  )}
                  {item.Vehicle_info.fule_type && (
                    <div>
                      <h6 className="text-muted">Fuel Type</h6>
                      <p className="fs_14px">{item.Vehicle_info.fule_type}</p>
                    </div>
                  )}
                </div>

                <div className="col-md-4">
                  <h6 className="text-muted">Dimensions:</h6>
                  {item.Vehicle_info.dimenstions.map((subitem) => (
                    <p className="fs_14px">{subitem}</p>
                  ))}
                </div>
                <div className="col-md-4">
                  <h6 className="text-muted">Sold By:</h6>{" "}
                  {item.Vehicle_info.sold_by.map((subitem) => (
                    <div className="p-1">
                      <input type="checkbox" disabled checked name="" id="" />

                      <label className="fs_14px ps-1" htmlFor="">
                        {subitem}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <h5 className="text_color text-decoration-underline">
                Vehicle KPI's:
              </h5>
              <div className="row">
                <div className="col-md-4">
                  <h6 className="text-muted">Best Uses:</h6>

                  {item.Vehicle_KPI.best_user.map((subitem) => (
                    <p className="fs_14px m-0">{subitem}</p>
                  ))}
                </div>

                <div className="col-md-4">
                  <h6 className="text-muted">Local Drivers:</h6>

                  {item.Vehicle_KPI.local_drivers.map((sub) => (
                    <p className="fs_14px m-0">{sub}</p>
                  ))}
                </div>

                <div className="col-md-4">
                  <h6 className="text-muted">Routes:</h6>
                  {item.Vehicle_KPI.routes.map((subitem) => (
                    <p className="fs_14px m-0">{subitem}</p>
                  ))}
                </div>
              </div>

              <h5 className="text_color text-decoration-underline mt-2">
                Drive Time:
              </h5>
              <div className="row">
                <div className="col-md-4">
                  <h6 className="text-muted">Hours:</h6>
                  <p>{item.drive_time.hours}</p>
                </div>

                <div className="col-md-4">
                  <h6 className="text-muted">Days:</h6>
                  <p className="fs_14px">{item.drive_time.days}</p>
                </div>
                <div className="col-md-4">
                  <h6 className="text-muted">Months:</h6>
                  <p className="fs_14px">{item.drive_time.months}</p>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center mt-2">
              {/* <div className=" ">
                <input
                  min={0}
                  type="number"
                  className="px-2 py-3"
                  name=""
                  id=""
                  style={{
                    borderRadius: "10px",
                    border: "none",
                    width: "6rem",
                    backgroundColor: "#D0DEE7",
                  }}
                  placeholder="0 Qty"
                />
              </div> */}
              <div>
                <button onClick={()=>navigate("/agency-packages")} className="btn btn_bg px-4 py-3">
                View Packages
                  {/* <FaShoppingCart size={25} style={{ paddingLeft: "5px" }} /> */}
                </button>
              </div>
            </div>
          </div>
        }
        isOpen={open}
        // loading={loading}
        yesName=""
        yesClick={handleSubmit}
        cancelName=""
        cancelClick={() => setopen(false)}
      />
    </>
  );
}

function EventCard({ open, setopen, item }) {
  const navigate = useNavigate();
  console.log(item);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  function handleSubmit() {}

  return (
    <>
      <PopupWithButton
        title=""
        content={
          <>
            <div className="row">
              <div
                className="col-2 d-flex align-items-center justify-content-center"
                onClick={() => setopen(false)}
              >
                <AiFillCloseCircle size={30} color={colors.primary} />
              </div>
              <div className=" col-7 d-flex align-items-center justify-content-center">
                {item.id === 4 ? (
                  <h4
                    className="text_color text-decoration-underline"
                    style={{ fontSize: "18px", whiteSpace: "nowrap" }}
                  >
                    {item.name}
                  </h4>
                ) : (
                  <h4
                    className="text_color text-decoration-underline"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {item.name}
                  </h4>
                )}
              </div>
              <div
                className=" col-3 d-flex align-items-center justify-content-end"
                style={{ width: "8rem" }}
              >
                <img
                  width={"100%"}
                  src={require("../assets/img/rolling_roz.png")}
                  alt=""
                />
              </div>
            </div>
            <Stack>
              <Slide>
                {item.Image?.map((item) => (
                  <div className=" each-slide-effect">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundSize: "cover",
                        height: "300px",
                        backgroundImage: `url(${item})`,
                      }}
                    >
                      {/* <span>Slide 1</span> */}
                    </div>
                  </div>
                ))}
              </Slide>
            </Stack>
            <div className="box_bg p-3 border border-secondary rounded mt-2">
              <h5 className="text_color text-decoration-underline">
                Product Description:
              </h5>
              <p>{item.description}</p>
            </div>
            <div className="d-flex justify-content-center align-items-center mt-2">
              {/* <div className=" ">
                <input
                  min={0}
                  type="number"
                  className="px-2 py-3"
                  name=""
                  id=""
                  style={{
                    borderRadius: "10px",
                    border: "none",
                    width: "6rem",
                    backgroundColor: "#D0DEE7",
                  }}
                  placeholder="0 Qty"
                />
              </div> */}
              <div>
                <button onClick={()=>navigate("/agency-packages")} className="btn btn_bg px-4 py-3">
                  View Packages
                  {/* <FaShoppingCart size={25} style={{ paddingLeft: "5px" }} /> */}
                </button>
              </div>
            </div>
          </>
        }
        isOpen={open}
        // loading={loading}
        yesName=""
        yesClick={handleSubmit}
        cancelName=""
        cancelClick={() => setopen(false)}
      />
    </>
  );
}
